import React, { useEffect, useState } from 'react';
import { FieldError, FieldValues, RefCallBack, UseFormRegister, useForm, useFormContext } from 'react-hook-form';
import get from 'lodash/get';
import { Modal } from 'react-bootstrap';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
interface IInputProps {
    observaciones: string,
    titulo: string
    errorColor?: boolean
}

const FormObservaciones: React.FC<IInputProps> = ({ observaciones, titulo, errorColor }) => {

    return (
        <>
            {observaciones && <div className={`card-link-block colored ${errorColor ? 'undetermined' : 'bright'}`}>
                <div className="container-isextinct">
                    <h3 className="card-link_title p-1 pb-3">{titulo}</h3>
                    <p className="text ">
                        {observaciones}
                    </p>
                </div>
            </div>

            }
        </>
    )
}

export default FormObservaciones;
